import { useState } from 'react';

import { useAuthContext } from '../Auth/context';
import { formatDate } from '../lib/timeFormat';
import { requestOffers, getSchedule, createBooking as create, getBestOffers } from './api';
import usePaginate from './usePaginate';
const useAPI = ({ setPendingBooking }) => {
  const [status, setStatus] = useState('initial');
  const [errorMessage, setErrorMessage] = useState(null);
  const [offers, setOffers] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [trips, setTrips] = useState([]);
  const [bestOffers, setBestOffers] = useState({ price: {}, general: {}, time: {} });

  const { state: { jwt } } = useAuthContext();

  const fetchMore = () => {
    if (offers.length > 0 && (status === 'request-complete' || status === 'request-failed')) {
      setStatus('should-fetch-more');
    }
  };

  const { page, resetPage, pausePaginate } = usePaginate({ fetchMore, status });

  const searchOffers = async ({ order, ...filters }) => {
    let newPage = page;

    if (status !== 'should-fetch-more') {
      newPage = resetPage();
    }

    let newStatus = status === 'should-fetch-more' ? 'fetching-more' : 'loading';
    setStatus(newStatus);

    try {
      const formattedFilters = {
        currency: filters.currency || 'SDG',
        origin: filters.departureStation?.iataCode,
        destination: filters.destinationStation?.iataCode,
        departureDate: formatDate(filters.departureDate, 'en'),
        returnDate: formatDate(filters.returnDate),
        tripType: filters.tripType,
        cabinClass: filters.cabinClass,
        slices: filters.slices?.map(slice => {
          return {
            origin: slice.departureStation.iataCode,
            destination: slice.destinationStation?.iataCode,
            departureDate: formatDate(slice.departureDate),
          };
        }),
        passengers: {
          adults: filters.adults,
          children: filters.children,
          infants: filters.infants
        },
        baggage: {
          hold: filters.hold,
          carryOn: filters.carryOn,
        },
      };

      if (filters.onlyDirect) formattedFilters.maxConnections = 0;

      const { data = {} } = await requestOffers(formattedFilters, { page: newPage, order });
      if (newStatus === 'loading') {
        const { data: { price: bestPrice, duration: bestDuration } = {} } = await getBestOffers(formattedFilters);

        if (bestPrice && bestDuration) setBestOffers({
          price: bestPrice[0],
          duration: bestDuration[0]
        });
      }

      if (data) {
        if (newStatus === 'fetching-more') {
          setOffers([...offers, ...data.offers]);
          if (data.offers.length === 0) pausePaginate();
        } else {
          setOffers(data.offers);
          setSuggestions(data.suggestions);
        }

        setStatus('request-complete');
      } else { }
    } catch (error) {
      setOffers([]);
      setErrorMessage('حدث خطأ في الشبكة, الرجاء المحاولة لاحقاَ');
      setStatus('request-failed');
    }
  };

  const createBooking = async ({ reference, ...payload }, filters = {}, guestUser, source, params) => {
    // setStatus('submitting');

    try {
      const { data } = await create(reference, { ...payload, ...filters }, { jwt });
      if (data.success)
        setPendingBooking({ bookingId: data?.booking?.id, source, params, guestUser });
      else {
        setErrorMessage('تعذر الحجز! الرجاء المحاولة مرة أخرى');
        setStatus('request-failed');
      }
    } catch (error) {
      setErrorMessage('تعذر الحجز! الرجاء المحاولة مرة أخرى');
      setStatus('request-complete');
    }
  };

  return {
    status,
    actions: { searchOffers, createBooking, fetchMore },
    data: { offers, bestOffers, trips, suggestions },
    errorMessage
  };
};

export default useAPI;
